import React from 'react'

import { TabelaColuna, TabelaDados } from 'src/componentes'
import { CategoriaTicketPorExtenso } from 'src/tipos'

export const colunaRequerimento = (): TabelaColuna => ({
  Chave: 'tipoRequerimento',
  Alinhamento: 'center',
  Renderizar: (linha: TabelaDados) => (
    <>{CategoriaTicketPorExtenso[linha.tipoRequerimento]}</>
  ),
  RenderizarCabecalho: () => <div style={{ width: 150 }}>Requerimento</div>
})
